// Avatars for everyone not currently in a cell. PLAN.md §2.2 #5.

import { useMemo } from 'react'
import { Avatar } from '../Avatar.js'
import { useStore } from '../../store.js'

export function SpectatorCrowd() {
  const players = useStore((s) => s.players)
  const self = useStore((s) => s.self)

  const list = useMemo(() => {
    const out: { id: string; seed: string; isMe: boolean }[] = []
    for (const p of players.values()) {
      const isMe = p.id === self?.player_id
      const optimisticInCell = isMe && self?.optimistic_target && self.optimistic_target !== 'spectator'
      const renderCell = optimisticInCell ? self.optimistic_target : p.cell
      if (renderCell !== 'spectator') continue
      out.push({ id: p.id, seed: p.avatar_seed, isMe })
    }
    return out
  }, [players, self])

  return (
    <div className="flex flex-wrap items-center justify-center gap-1.5 px-2 py-2 min-h-7">
      {list.map((p) => (
        <Avatar key={p.id} seed={p.seed} isMe={p.isMe} />
      ))}
    </div>
  )
}
